/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_transactions = {
    readonly edges?: ReadonlyArray<{
        readonly node: {
            readonly skuId: string | null;
            readonly isPrivateOffer: boolean | null;
            readonly isCanceled: boolean | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSwatchSelector_transactions">;
    readonly " $refType": "PdpRespContainer_transactions";
};
export type PdpRespContainer_transactions$data = PdpRespContainer_transactions;
export type PdpRespContainer_transactions$key = {
    readonly " $data"?: PdpRespContainer_transactions$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_transactions">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_transactions",
  "type": "TransactionConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMultiSku",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TransactionEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Transaction",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "skuId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isPrivateOffer",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isCanceled",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_transactions",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'e77eb4f6632d5f4ae6a0788596ba16ed';
export default node;
